import type { MercuryEntityATI } from '@atlassian/search-client/common/types';

export const DEFAULT_MERCURY_ENTITY_ATI: MercuryEntityATI[] = [
	'ati:cloud:mercury:focus-area',
	'ati:cloud:mercury:focus-area-status-update',
];
